import { useEffect, useRef, useState } from "react";
import MailIcon from "../../assets/svg/contact/MailIcon.svg";
import UploadIcon from "../../assets/svg/contact/uil_upload.svg";
import {
  CONTACT_SUPPORT_URL,
  PRIORITIES_URL,
  SECTIONS_URL,
} from "../../service/API_URL";
import axiosInstance from "../../service/axiosPublicInstance";
import "./ContactUs.scss";
import { toast, ToastContainer } from "react-toastify";
import {
  contactUsDefaults,
  contactUsErrors,
} from "../../dummyjson/contactUsDefaults";

const ContactUs = () => {
  const textareaRef = useRef(null);
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState({
    ...contactUsDefaults,
  });
  const [isFileAttached, setIsFileAttached] = useState(false);
  const [attachmentPreview, setAttachmentPreview] = useState("");
  const [errors, setErrors] = useState({
    ...contactUsErrors,
  });
  const [loading, setLoading] = useState(false);
  const [priorities, setPriorities] = useState([]);
  const [sections, setSections] = useState([]);

  const options = ["Option 1", "Option 2", "Option 3", "Option 4"];
  const [selectedOption, setSelectedOption] = useState(options[0]);
  useEffect(() => {
    if (sections) {
      console.log("sections", sections);
    }
  }, [sections]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [prioritiesResponse, sectionsResponse] = await Promise.all([
          axiosInstance.get(PRIORITIES_URL, {
            headers: { "X-TENANT-ID": "runn" },
          }),
          axiosInstance.get(SECTIONS_URL, {
            headers: { "X-TENANT-ID": "runn" },
          }),
        ]);

        setPriorities(
          Array.isArray(prioritiesResponse?.data?.data)
            ? prioritiesResponse?.data?.data
            : []
        );
        console.log(
          "Array.isArray(prioritiesResponse.data) ? prioritiesResponse?.data : []",
          prioritiesResponse?.data?.data
        );
        setSections(
          Array.isArray(sectionsResponse?.data?.data)
            ? sectionsResponse?.data?.data
            : []
        );
        console.log(
          "Array.isArray(sectionsResponse.data) ? sectionsResponse?.data : []",
          sectionsResponse?.data?.data
        );
      } catch (error) {
        console.error("Error fetching priorities or sections:", error);
        setErrors((prevErrors) => ({
          ...prevErrors,
          priority:
            "Failed to fetch priorities or sections. Please try again later",
        }));
      }
    };

    fetchData();
  }, []);
  const isEmailValid = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      if (file) {
        const isValidType =
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/png";
        // const isValidSize =
        //   file.size >= 1 * 1024 * 1024 && file.size <= 10 * 1024 * 1024;
        const isValidSize = file.size <= 10 * 1024 * 1024;

        if (!isValidType || !isValidSize) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            attachment: "Please upload a .jpg/.jpeg or .png image below 10MB.",
          }));
          setIsFileAttached(false);
          setAttachmentPreview("");
          return;
        } else {
          setErrors({ ...contactUsErrors });
          setIsFileAttached(true);

          // Revoke previous preview URL if exists
          if (attachmentPreview) {
            URL.revokeObjectURL(attachmentPreview);
          }
          // Set preview URL for the new file
          setAttachmentPreview(URL.createObjectURL(file));
        }
      }
    }
    const textarea = textareaRef.current;
    textarea.style.height = textarea.scrollHeight + "px";
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));

    if (type !== "file" && value.length > 1) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
    if (type === "email") {
      if (!isEmailValid(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Enter valid email",
        }));
      }
    }
  };

  const validateForm = () => {
    console.log("errors", errors);
    for (const key in formData) {
      if (!formData[key] && key !== "attachment") {
        // if (key === "attachment") {
        //   setErrors((prevErrors) => ({
        //     ...prevErrors,
        //     attachment:
        //       "Please upload a JPEG or PNG image between 1MB and 10MB.",
        //   }));
        //  return false;
        // }

        if (formData[key]?.length < 1) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "Please fill all the fields.",
          }));
        }

        return false;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: "",
        }));
      }
    }
    return true; // Return true if the form is valid, false otherwise
  };
  const handleRemove = () => {
    if (attachmentPreview) {
      URL.revokeObjectURL(attachmentPreview);
    }
    setFormData((prevData) => ({
      ...prevData,
      attachment: null,
    }));
    setIsFileAttached(false);
    setAttachmentPreview("");
    setErrors({ ...contactUsErrors });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("validateForm()", validateForm());

    if (validateForm()) {
      const formDataToSend = new FormData();
      formDataToSend.append("email", formData.email);
      formDataToSend.append("section", formData.section);
      formDataToSend.append("message", formData.issue);
      formDataToSend.append("priority", formData.priority);

      if (formData.attachment) {
        formDataToSend.append("attachment", formData.attachment);
      }

      setLoading(true);
      try {
        const response = await axiosInstance.post(
          CONTACT_SUPPORT_URL,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "X-TENANT-ID": "runn",
            },
          }
        );

        setFormData({
          ...contactUsDefaults,
        });
        setIsFileAttached(false);
        setAttachmentPreview("");
        setErrors({ ...contactUsErrors });
      } catch (error) {
        console.error(
          "Error submitting form:",
          error.response ? error.response.data : error.message
        );
        toast.error(
          "There was an error submitting your form. Please try again.",
          {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 3000,
          }
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="" style={{ backgroundColor: "#1A1A1A" }}>
      <div className="popup-content">
        <h2 className="heading-text">Contact Us</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-subtext">
            <label htmlFor="email">
              Email <span>*</span>
            </label>
            <div
              className="form-input"
              style={{ position: "relative", height: "48px" }}
            >
              <img
                src={MailIcon}
                alt="Mail Icon"
                style={{
                  position: "absolute",
                  left: "21px",
                  top: "49%",
                  transform: "translateY(-50%)",
                  height: "15px",
                  pointerEvents: "none",
                }}
              />
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                className="custom-input"
                style={{
                  paddingLeft: "55px",

                  boxSizing: "border-box",
                  color: "#999999",
                  borderRadius: "6px",
                  backgroundColor: "#FFFFFF14",
                  height: "48px",
                }}
              />
            </div>
            {errors.email && (
              <p className="error-msg">
                {formData.email.length < 1 ? "Email is required" : errors.email}
              </p>
            )}
          </div>

          <div className="form-group-contact  ">
            <div className="form-item form-lable">
              <label htmlFor="section">
                Section <span>*</span>
              </label>
              <select
                // style={{ width: "188px" }}
                id="section"
                name="section"
                value={formData.section}
                onChange={handleChange}
                className="custom-select-dropdown"
              >
                <option value="">Select Section</option>
                {sections?.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {errors.section && (
                <p className="error-msg">
                  {formData.section ? errors.section : "Section is required"}
                </p>
              )}
            </div>

            <div className="form-item">
              <label htmlFor="priority">
                Priority <span>*</span>
              </label>
              <select
                id="priority"
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                className="custom-select-dropdown"
              >
                <option value="">Select Priority</option>

                {priorities?.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {errors.priority && (
                <p className="error-msg">
                  {formData.priority ? errors.priority : "Priority is required"}
                </p>
              )}
            </div>
          </div>

          <div className="form-subtext">
            <label htmlFor="issue">
              Issue <span>*</span>
            </label>

            <textarea
              placeholder="Describe the issue"
              className="label-bg-details customTextArea"
              name="issue"
              value={formData.issue}
              ref={textareaRef}
              style={{
                height: formData.issue?.length !== 0 ? "auto" : "48px",
              }}
              onChange={handleChange}
              wrap="soft" // allows word wrapping
            />
            {errors.issue && (
              <p className="error-msg">
                {formData.issue?.length !== 0
                  ? errors.issue
                  : "Issue is required"}
              </p>
            )}
          </div>

          <div className="form-subtext">
            <label htmlFor="attachment">Attachment</label>
            <div className={`${isFileAttached ? "" : "upload-dashline"}`}>
              <div className="file-upload">
                {isFileAttached ? (
                  <div
                    className="attachment-container"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img
                      src={attachmentPreview}
                      alt="Attachment Preview"
                      className="thumbnail-preview"
                      style={{
                        width: "32px",
                        height: "32px",
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                    />
                    <span
                      className="file-name"
                      style={{
                        marginLeft: "16px",
                        color: "#BFBFBF",
                        fontSize: "14px",
                        maxWidth: "180px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {formData.attachment?.name}
                    </span>
                    <button
                      type="button"
                      className="cross-icon-button"
                      onClick={handleRemove}
                      style={{ marginLeft: "16px" }}
                    >
                      <span className="cross-icon">✖</span>
                    </button>
                  </div>
                ) : (
                  <>
                    <span className="upload-icon">
                      <img src={UploadIcon} alt="Upload Icon" />
                    </span>
                    <span className="upload-text">
                      Image (.jpg/.jpeg or .png below 10MB)
                    </span>
                  </>
                )}
                <input
                  type="file"
                  id="attachment"
                  name="attachment"
                  onChange={handleChange}
                  style={{ display: "none" }}
                  ref={fileInputRef}
                />
                {!isFileAttached && (
                  <div
                    className="browse-button"
                    onClick={() =>
                      fileInputRef.current && fileInputRef.current.click()
                    }
                  >
                    Browse
                  </div>
                )}
              </div>
            </div>
            {errors.attachment && (
              <p className="error-msg">{errors.attachment}</p>
            )}
          </div>

          <div className="">
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ContactUs;
